import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wrench, X } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../i18n/LanguageContext";

export default function ShopClosedBanner() {
  const { t } = useLang();
  const [closed, setClosed] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("mt_closed_dismissed") === "1");

  useEffect(() => {
    api.get("/settings/shop").then((r) => setClosed(r.data.shop_open === false)).catch(() => {});
  }, []);

  if (!closed || dismissed) return null;

  return (
    <div data-testid="maintenance-banner" className="fixed top-16 md:top-20 inset-x-0 z-40 bg-gold text-ink shadow-lg">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-center gap-3 text-sm">
        <Wrench className="w-4 h-4 shrink-0" />
        <p className="text-center">
          {t("maintenance.message")}{" "}
          <Link to="/catalogues" data-testid="maintenance-cta" className="font-semibold underline underline-offset-2 hover:opacity-80 transition-opacity">
            {t("maintenance.cta")}
          </Link>
        </p>
        <button
          data-testid="maintenance-dismiss"
          onClick={() => { sessionStorage.setItem("mt_closed_dismissed", "1"); setDismissed(true); }}
          className="p-1 hover:opacity-70 transition-opacity shrink-0"
          aria-label="Fermer"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
